import {recalc} from '@/app/js/handle-payment-counters'

export function handleProductFancy() {
  const tradeBtnEls = document.querySelectorAll('.js-product-trade-form')
  if (tradeBtnEls) {
    tradeBtnEls.forEach(tradeBtnEl => {
      tradeBtnEl.addEventListener('click', () => {
        const productNameEl = document.querySelector(tradeBtnEl.dataset.src + ' .js-product-name')
        if (productNameEl) productNameEl.textContent = tradeBtnEl.dataset.product
      })
    })
  }

  const buttonEls = document.querySelectorAll('.js-open-fancy-form')
  if (buttonEls.length) {
    buttonEls.forEach(buttonEl => buttonEl.addEventListener('click', () => {
      $.fancybox.close()
      recalc()
      $.fancybox.open({
        src: buttonEl.dataset.src
      })
    }))
  }

  const testDriveBtnEls = document.querySelectorAll('.js-product-form-test-drive')
  if (testDriveBtnEls.length) {
    testDriveBtnEls.forEach(buttonEl => buttonEl.addEventListener('click', () => {
      // const formEl = document.querySelector(buttonEl.dataset.src)
      // formEl.querySelector('[name="user_message"]').placeholder = buttonEl.dataset.placeholder

      $.fancybox.open({
        src: buttonEl.dataset.src
      })
    }))
  }

  const buyBtnEls = document.querySelectorAll('.js-product-buy')
  if (buyBtnEls) {
    buyBtnEls.forEach( buyBtnEl => {
      buyBtnEl.addEventListener('click', e => {
        e.preventDefault()

        const productCostTextEl = document.querySelector('#form_9_3 .js-product-cost-text')
        const productCostInputEl = document.querySelector('#form_9_3 .js-product-cost-input')
        const productCarNameEl = document.querySelector('#form_9_3 .js-car-name')
        const productInitialFeeEl = document.querySelector('#form_9_3 .js-payment-counter-first-payment')
        const productCreditTermEl = document.querySelector('#form_9_3 .js-payment-counter-term')

        if (productCostTextEl) productCostTextEl.textContent = buyBtnEl.dataset.price
        if (productCostInputEl) productCostInputEl.value = buyBtnEl.dataset.price
        if (productCarNameEl) productCarNameEl.textContent = buyBtnEl.dataset.carName
        if (productInitialFeeEl) productInitialFeeEl.value = buyBtnEl.dataset.initialFee
        if (productCreditTermEl) productCreditTermEl.value = buyBtnEl.dataset.creditTerm

        $.fancybox.open({
          src: buyBtnEl.dataset.src
        })
      })
    })
  }
}
